export default {
  'Add Cut': 'Adicionar Clip de Vídeo',
}